import { KeyValue } from '@/main/models/common';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import { CompanyAnnouncementFilterRequest } from '@/main/models/request';
import {
  AnnouncementCompaniesRequest,
  AnnouncementFilterRequest,
  AnnouncementSaveRequest,
  AnnouncementCompaniesSaveRequest,
  CompanyAnnouncerFilterRequest
} from '@/main/models/request/announcementRequest';
import {
  AnnouncementCompaniesResponse,
  AnnouncementDetailResponse,
  AnnouncementFileResponse,
  CompaniesAvailableResponse
} from '@/main/models/response/announcementResponse';
import { AxiosResponse } from 'axios';

export abstract class IAnnouncementApi {
  abstract getAnnouncements(
    request: AnnouncementFilterRequest
  ): Promise<AxiosResponse<any>>;

  abstract getStatusDomain(
    showExpired?: boolean
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract save(
    request: AnnouncementSaveRequest,
    file: File | null
  ): Promise<AxiosResponse<Result<string>>>;
  abstract getDomainAnnouncements(guidCompany?: string): Promise<AxiosResponse<Result<KeyValue[]>>>;
  abstract getAvailableCompaniesAnnouncement(
    request: CompanyAnnouncementFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<CompaniesAvailableResponse>>>;

  abstract getDomainCompanyAnnouncers(request: CompanyAnnouncerFilterRequest): Promise<
    AxiosResponse<Result<KeyValue[]>>
  >;

  abstract getDomainWhoCanSee(): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract saveCompanies(
    request: AnnouncementCompaniesSaveRequest
  ): Promise<AxiosResponse<Result<boolean>>>;

  abstract getDetailCompaniesWillSee(
    request: AnnouncementCompaniesRequest
  ): Promise<AxiosResponse<PaginationResponse<AnnouncementCompaniesResponse>>>;

  abstract getDetail(
    guidAnnouncement: string
  ): Promise<AxiosResponse<Result<AnnouncementDetailResponse>>>;

  abstract getFile(
    guidAnnouncement: string
  ): Promise<AxiosResponse<Result<AnnouncementFileResponse>>>;

  abstract copyAnnouncement(
    guidAnnouncement: string
  ): Promise<AxiosResponse<Result<string>>>;
}
